import DatePicker from "react-datepicker";
import Modal from "@/components/ui/Modal";
import HelpModal from "./HelpModal";

import CalenderIcon from "@/assets/icons/CalenderGray.svg";
import { useState } from "react";
import { FileDetails } from "@/types/types";
import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import { useUploadPurchasingInvoiceMutation } from "@/redux/feature/orderManagement/productShipping/productShippingApi";
import toast from "react-hot-toast";
import { handleApiRequest } from "@/utils/handleApiRequest";
import FileUploadField from "@/components/ui/FileUploadField";

// Component for product purchase view
type Value = Date | null | undefined;

const ProductPurchaseView = ({
  isCreatorBuyingtheProduct,
}: {
  isCreatorBuyingtheProduct: boolean;
}) => {
  const [clearFiles, setClearFiles] = useState(false);
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Value>(new Date());
  const [file, setFile] = useState<FileDetails | null>(null);

  const [loading, setIsLoading] = useState(false);
  const { orderId, videoId } = useOrderVideoParams();

  const [uploadPurchasingInvoice] = useUploadPurchasingInvoiceMutation();
  // Function to handle shipping invoice submission
  const handleUploadPurchasingInvoice = async () => {
    if (!file?.live_url) {
      return toast.error("Please upload an invoice!");
    }

    const payload = {
      order_id: orderId,
      video_id: videoId,
      data: {
        expected_delivery_date: selectedDate,
        purchase_invoice: file,
      },
    };

    setIsLoading(true);
    await handleApiRequest({
      payload,
      requestFunction: uploadPurchasingInvoice,
      onSuccess: () => {
        toast.success("Uploaded");
        setIsLoading(false);
      },
      onError: (err) => {
        toast.error(err.data.message || "Something went wrong");
        setIsLoading(false);
      },
    });
  };

  return (
    <div className="m-5">
      <div className="text-xs font-medium tracking-[-1%] flex gap-x-1">
        <p className="text-[#98A2B3] leading-4">Disclaimer - </p>
        <p className="text-[#667085] leading-[18px]">
          The Product is to be bought by Creator through the provided link in
          the product description. Creator will be compensated for the amount
          spent for the purchase.
        </p>
      </div>

      {/* Expected Delivery Date */}
      {/* <div className="px-[12px] mt-4 flex items-center w-fit border border-[#D0D5DD] rounded-[10px]">
        <p className="text-[#363636] py-[10px] text-sm pr-[12px]">
          Expected Date of Delivery
        </p>
        <button className="text-[#959FB2] leading-[15px] flex items-center py-[10px] border-[#D0D5DD] px-[12px] text-sm border-l">
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="dd/MM/yyyy"
            minDate={new Date()}
            className="w-[125px] cursor-pointer pl-4 focus:outline-none"
            popperPlacement="bottom-start"
          />
          <CalenderIcon />
        </button>
      </div> */}
      <div className="border-t border-[#E5E9EB] mt-4">
        <p className="text-[#344054] text-sm font-medium leading-5 mb-2 mt-4">
          Has the product been purchased by you? If yes, please upload the order
          invoice
        </p>
        <div className="rounded-[10px]">
          <FileUploadField
            clearFiles={clearFiles}
            onFilesUploaded={(file) => setFile(file[0])}
            maxFiles={1}
          />
        </div>
      </div>
      {/* Submit Button */}
      <div className="flex justify-end mt-4">
        <button
          onClick={handleUploadPurchasingInvoice}
          disabled={loading && !file?.live_url}
          className="text-white px-6 disabled:opacity-55 text-sm py-2 font-semibold rounded-lg bg-[#17457D]"
        >
          {loading ? "Submitting" : "Submit"}
        </button>
      </div>
      <p
        className="text-xs leading-5 font-medium px-5 pb-4 cursor-pointer"
        onClick={() => setHelpModalOpen(true)}
      >
        <span className="text-[#344054]">Experiencing issues?</span>{" "}
        <span className="text-[#F66D00]">Help</span>
      </p>
      <Modal
        isOpen={helpModalOpen}
        setOpen={setHelpModalOpen}
        padding="24px"
        width="420px"
      >
        <HelpModal
          isCreatorBuyingProduct={isCreatorBuyingtheProduct}
          onClose={setHelpModalOpen}
        />
      </Modal>
    </div>
  );
};

export default ProductPurchaseView;
